import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { english } from '../../i18n/en';
import { norwegian } from '../../i18n/nb';
import { TranslationLoaderService } from '@core/services/translation-loader.service';
import { TRANSLATION_SCOPE } from '@modules/instructor/i18n/scope';

@Component({
  selector: 'app-instructor-wrapper',
  templateUrl: './instructor-wrapper.component.html',
  styleUrls: ['./instructor-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InstructorWrapperComponent implements OnInit {
  constructor(private translationLoader: TranslationLoaderService) {
    this.translationLoader.loadTranslations(TRANSLATION_SCOPE,english, norwegian);
  }

  ngOnInit() {}
}
